<script setup lang="ts">
import { useGuiStore } from '@/stores';
import { BibAssignPreview } from '@/objects/generated';
import { ContentComp, ListComp } from '@/components';
import { ref, watch } from 'vue';
import { BibAssignDao } from '@/dao';
import { useTaskLoader } from '@/composeables';
import type ListCompExpose from '@/objects/ListCompExpose';
import { useElementVisibility } from '@vueuse/core';
import type { GridColumnOptions } from '@/components/Grid/Classes';

const { AddLoader, LoadState } = useTaskLoader();
const guiStore = useGuiStore();

// The container ref
const container = ref<HTMLElement | null>(null);
// Check if the container is visible
const isVisible = useElementVisibility(container);

const props = defineProps<{
    EventID: number;
    KeepAssigned: boolean;
    OverwriteStartTimes: boolean;
    Shuffle: boolean;

    /**
     * Custom columns to add to the grid
     * These are columns that are not defined in the Gui definition
     * @default []
     */
    customColumns?:
        | Array<GridColumnOptions<BibAssignPreview>>
        | ((columns: Array<GridColumnOptions<BibAssignPreview>>) => Array<GridColumnOptions<BibAssignPreview>>);
}>();

const list = ref<BibAssignPreview[]>([]);

const listcomp = ref<ListCompExpose<BibAssignPreview> | null>(null);
// AddLoader(async () => {
//     list.value = await BibAssignDao.BibAssignPreview(props.EventID, props.KeepAssigned, props.Shuffle);
//     listcomp.value?.dataUpdated();
// }, 'general.loading');

watch(
    isVisible,
    () => {
        console.log('Visibility changed:', isVisible.value);

        if (isVisible.value) {
            list.value = [];
            listcomp.value?.dataUpdated();
            AddLoader(async () => {
                list.value = await BibAssignDao.BibAssignPreview(
                    props.EventID,
                    props.KeepAssigned,
                    props.Shuffle,
                    props.OverwriteStartTimes,
                );
                listcomp.value?.dataUpdated();
                listcomp.value?.resizeColumns();
            }, 'general.loading');
        }
    },
    { immediate: true },
);
</script>
<template>
    <ContentComp
        :loadState="LoadState"
        :showAsModal="true"
        ref="container"
        class="vh-50"
    >
        <ListComp
            :baseType="BibAssignPreview"
            :gui="guiStore.BibAssignPreview"
            :customColumns="props.customColumns"
            v-model="list"
            :hideToolbar="true"
            ref="listcomp"
            resizeStrategy="sizeColumnsToFit"
        />
    </ContentComp>
</template>
